<div class="accordion-container">
  <!-- Header Section with Pagination and Sorting -->
  <div *ngIf="!showTestPlanHeader && totalItems">
    <div class="accordion-header-bar" *ngIf="showHeader && (paginationConfig || sortOptions.length > 0)">
    <div class="pagination-info" *ngIf="paginationConfig">
      <span *ngIf="!selectedSection">Showing <strong>{{ currentStart }}</strong> to <strong>{{ currentEnd }}</strong> of <strong>{{ totalItems }}</strong> {{ paginationInfo?.label || 'items' }}</span>
      <span *ngIf="selectedSection"> <strong>{{ selectedSection.name || selectedSection.testSuiteName }}</strong> selected</span>
    </div>
    
    <div class="sort-options" *ngIf="sortOptions.length > 0 && typeId === 'custom_test_suites_accordion'">
      <span class="sort-label">Sort by:</span>
      <div class="sort-buttons">
        <button 
          *ngFor="let option of sortOptions"
          class="sort-button"
          [class.active]="selectedSort?.id === option.id"
          (click)="toggleSortDirection(option)">
          {{ option.label }}
          <span class="sort-icon" *ngIf="option.id === 'test-case-count'">
             <img [src]="
             selectedSort?.id === option.id
               ? 'assets/images/virtusa-icons/doubleArrow-light.svg':'assets/images/virtusa-icons/sort-arrows.svg'" alt="arrow" />
          </span>
        </button>
      </div>
    </div>
  </div>
  </div>

  <div class="accordion-header-bar test-plan-header" *ngIf="showHeader && showTestPlanHeader">
    <!-- Left side: Select All checkbox OR pagination info, controlled by showSelectAll -->
    <div class="d-flex align-items-center" *ngIf="showSelectAll">
      <input type="checkbox" id="selectAll" class="form-check-input me-2" [(ngModel)]="isSelectAllChecked" (change)="onSelectAllChange(isSelectAllChecked)">
      <label for="selectAll" class="form-check-label">Select All</label>
    </div>
    <div class="pagination-info" *ngIf="!showSelectAll">
      <span><strong>{{ currentStart }}</strong> - <strong>{{ currentEnd }}</strong> of <strong>{{ totalItems }}</strong> {{ paginationInfo?.label || 'items' }}</span>
    </div>
    <div class="d-flex align-items-center gap-3">
      <div class="d-flex align-items-center gap-2">
        <div class="form-check form-switch mb-0">
          <input class="form-check-input" type="checkbox" id="setAsDefault" [(ngModel)]="isSwitchEnabled" (change)="onSwitchToggle()">
        </div>
        <label class="form-check-label" for="setAsDefault">Set as Default</label>
      </div>
      <div class="dropdown1-wrapper" [class.dropdown1-wrapper--disabled]="!isSwitchEnabled">
        <app-menu-dropdown
          [selectedValue]="dropdown1Value"
          [placeholderText]="dropdown1Placeholder"
          [data]="dropdown1Options"
          (onSelect)="onDropdown1Change($event)">
        </app-menu-dropdown>
      </div>

      <div class="browser-custom-select" [class.disabled]="!isSwitchEnabled" (click)="toggleDropdown2($event)" (keydown.enter)="toggleDropdown2($event)" >
        <div class="browser-trigger">
          <img *ngIf="dropdown2Value" [src]="getBrowserImage(dropdown2Value)" class="browser-icon-sel" alt="browser"/>
          <span *ngIf="!dropdown2Value" class="browser-placeholder">{{ dropdown2Placeholder }}</span>
        </div>
        <div class="browser-panel" *ngIf="dropdown2Open">
          <div *ngFor="let opt of dropdown2Options"
               class="browser-panel-opt"
               [class.active]="dropdown2Value === opt.value"
               (click)="onDropdown2Select($event, opt.value)" (keydown.enter)="onDropdown2Select($event, opt.value)">
            <img [src]="opt.image || ''" [alt]="opt.label" class="browser-icon-opt" />
          </div>
        </div>
      </div>

      <div class="tph-vertical-sep"></div>

      <button class="tph-save-btn" *ngIf="showSaveButton"
              (click)="onSaveClick()"
              [disabled]="isSaveLoading || (showSectionCheckbox && !hasAnySelected)"
              [class.tph-save-btn--disabled]="showSectionCheckbox && !hasAnySelected && !isSaveLoading">
        <span *ngIf="isSaveLoading" class="tph-save-spinner"></span>
        <ng-container *ngIf="!isSaveLoading">
          <img src="assets/images/virtusa-icons/save-icon.svg" alt="save" class="tph-save-icon" />
        </ng-container>
        {{ isSaveLoading ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </div>

  <div class="accordion-section" 
       *ngFor="let section of paginatedSections"
       [class.no-border]="paginatedSections.length === 1"
       [class.dimmed]="hasAnySelected && !section.isSelected && singleSectionSelection">
    <!-- Accordion Header -->
    <div class="accordion-header"
         [class.selected]="section.isSelected"
         (click)="toggleSection(section)" (keydown.enter)="toggleSection(section)">
      <div class="header-content flex-grow-1">
        <div class="header-date">
            <div class="section-date-badge" *ngIf="section.createdAt && typeId === 'test_plan_list_accordion'"
              matTooltip="Created Date"
              matTooltipPosition="above">
              <img src="assets/images/virtusa-icons/calender.svg" alt="date" class="section-date-badge-icon" />
              {{ formatDate(section.createdAt) }}
            </div>
            <div class="header-name">
              <input
                *ngIf="showSectionCheckbox"
                type="checkbox"
                class="form-check-input me-2"
                [(ngModel)]="section.isSelected"
                [disabled]="singleSectionSelection && hasAnySelected && !section.isSelected"
                (ngModelChange)="onSectionCheckboxChange(section)"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
              />
              <h3 class="section-title m-auto flex-grow-1">{{ section.isDefault ? 'Test Scripts' : (section.name || section.testSuiteName || section.testPlanName || section.mappingName) }}<span class="default-badge" *ngIf="section.isDefault">Default</span></h3>
              <div class="paradigm-section " *ngIf="section?.paradigm" [class.paradigm-mobile]="section.paradigm?.toLowerCase() === 'mobile'">
                {{section?.paradigm}}<span *ngIf="section.paradigm?.toLowerCase() === 'mobile' && section?.mobileAppType" class="mobile-app-type"> ({{section.mobileAppType}})</span>
              </div>
              <div *ngIf="info.display" class="v-center">
                <img src="assets/images/virtusa-icons/info-gray.png" alt="info" class="info-icon" [title]="info.tooltip"
                  (click)="$event.stopPropagation(); infoIconClick.emit({ data: section })"
                  (keydown.enter)="$event.stopPropagation(); infoIconClick.emit({ data: section })" />
              </div>
            </div>
        </div>
        
        <div class="d-flex flex-row justify-content-end align-items-center">
		<div class="size-section" [hidden]="hideTcCount">
			<img src="assets/images/virtusa-icons/page.svg" alt="page" />
			<span class="item-count">{{ section?.testcaseCount ?? section?.pageCount ?? section?.scriptCount }} {{ itemLabel }}</span>
		</div>
    
    <!-- Mobile Platform Section -->
		<div class="mobile-platform-section">
			<img *ngIf="section?.mobilePlatform && section.mobilePlatform !== null" class="broswer-icon" [src]="'assets/images/virtusa-icons/' + section?.mobilePlatform?.toLowerCase() + '.svg'" alt="mobile platform icon" />
			<span *ngIf="section?.paradigm && (!section?.mobilePlatform || section.mobilePlatform === null)" class="browser-placeholder">-</span>
		</div>
    
		<!-- Browser Section -->
		<div class="browser-section">
			<img *ngIf="section?.browser && section.browser !== null" class="broswer-icon" [src]="'assets/images/virtusa-icons/' + section.browser?.toLowerCase() + '.svg'" alt="browser icon" />
			<span *ngIf="section?.paradigm && (!section?.browser || section.browser === null)" class="browser-placeholder">-</span>
		</div>
      
      <button class="toggle-button">
        <img *ngIf="section.expanded" src="assets/images/virtusa-icons/remove-outline.svg" alt="add" />
		<img *ngIf="!section.expanded" src="assets/images/virtusa-icons/add-outline.svg" alt="add" />
      </button>
    </div>
    </div>
</div>
    <!-- Accordion Content (Expanded) -->
    <div class="accordion-content" *ngIf="section.expanded">
      <!-- Loading State -->
      <div class="loading-state" *ngIf="section.loading">
        <div class="spinner"></div>
        <span>Loading...</span>
      </div>
      
      <!-- Table Content (if tableColumns and tableRows are provided) -->
      <div class="table-content" *ngIf="!section.loading && section.tableColumns && section.tableRows">
        <app-zorro-table
          [columns]="section.tableColumns"
          [data]="section.tableRows"
          [options]="defaultTableOptions"
          (onRowSelect)="onTableRowSelect($event, section)"
          (handleActions)="handleTableActions($event, section)">
        </app-zorro-table>
      </div>
      
      <!-- Empty State -->
      <div class="empty-state" *ngIf="!section.loading && !section.data && !section.tableRows">
        <span>No data available</span>
      </div>
    </div>
  </div>

  <!-- Pagination Controls -->
  <div class="pagination-bar justify-content-center" *ngIf="showPagination && paginationConfig">
    <nz-pagination 
      [nzPageIndex]="paginationConfig.currentPage" 
      [nzTotal]="paginationConfig.total"
      [nzPageSize]="paginationConfig.pageSize"
      [nzShowSizeChanger]="false"
      [nzPageSizeOptions]="[5, 10, 20, 50, 100]"
      (nzPageIndexChange)="onPageIndexChange($event)"
      (nzPageSizeChange)="onPageSizeChange($event)">
    </nz-pagination>
  </div>
</div>